import { collection, onSnapshot, orderBy, query, Timestamp, where } from 'firebase/firestore';
import { firestoreDb } from './FirebaseConfig';

/**
 * Substitui o hub SignalR legado (EsteiraWebSocket.js, nunca implementado no backend —
 * ver ARCHITECTURE.md) por push nativo via Firestore: o board de /andamento-contas e
 * /mapa-resultado assina os eventos de movimentação de cartão da própria esteira, sem
 * polling. Autorização (só quem tem acesso àquela empresa/esteira) é feita pelas
 * Security Rules do Firestore (ver terraform/firestore.rules), usando o custom claim
 * "clienteId" setado no login (Ainumera.Core/Services/AuthService.cs).
 */
export const subscribeToEsteira = (
  esteiraId: number | string,
  onEvento: (evento: { conta: string; status: string; porcentagem: number | null; detalhes: any }) => void
): (() => void) => {
  const desde = Timestamp.now();
  const notificacoesRef = collection(firestoreDb, 'esteiras', String(esteiraId), 'notificacoes');
  const q = query(notificacoesRef, where('timestamp', '>', desde), orderBy('timestamp'));

  return onSnapshot(
    q,
    (snapshot) => {
      snapshot.docChanges().forEach((change) => {
        if (change.type !== 'added') return;

        const data = change.doc.data();
        onEvento({
          conta: data.conta,
          status: data.status,
          porcentagem: data.porcentagem ?? null,
          detalhes: {
            Etapa: data.etapa,
            TotalLancamentos: data.totalLancamentos,
            Pendentes: data.pendentes,
            Inicio: data.inicio,
            Fim: data.fim,
            Usuario: data.usuario,
          },
        });
      });
    },
    (error) => {
      console.error(`Erro ao assinar notificações da esteira ${esteiraId}`, error);
    }
  );
};
